export function formatDate(stringDate) {
  const date = new Date(stringDate);
  return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
}


// WEBPACK FOOTER //
// ./src/utils/formatDate.js